import { v4 as uuidv4 } from 'uuid';

export const version = () => '4.1.21';

export const getDUID = () => `SCAP-${uuidv4().toUpperCase()}`;

export const getDeviceId = () => {
  // NOTE: This is for backwards compatibility and can be removed once all users are using the new version of the app.
  // Old versions of the app stored the SCAPDeviceId in localStorage and this allows the new version of our store
  // to use that existing device id, so that users do not have to re-pair.
  /*const currentDeviceId = localStorage.getItem('bd-canvas-web-app__device-id');
  localStorage.removeItem('bd-canvas-web-app__device-id');*/

  const newId = localStorage.getItem("DeviceID");
  if (newId !== null) {
    return newId;
  }
  const oldId = getDUID();
  return oldId;
};
